import React from 'react'
import { Redirect } from 'react-router-dom'

import store from '../../store/Store'
import actions from '../../actions/Actions'
import routes from '../../routes/Routes'

import EditorOverviewItem from './../editorOverviewItem/EditorOverviewItem'

import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined'

import Icon from "@material-ui/core/Icon"
import IconButton from '@material-ui/core/IconButton'

import './editorOverview.scss'

type editorContentState = {
	article: any;
	history: any;
}

type editorContentProps = {
	article: any;
	history: any;
}

class EditorOverview extends React.Component<editorContentState, editorContentProps> {

  constructor(props) {
  	super(props)

  	this.state = {
  		article: props.article,
  		history: props.history
  	}
  }

  componentDidMount() {
	store.subscribe(() => {
		this.setState({
			article: store.getState().article
		})
	})
  }

  componentWillUnmount() {
	store.subscribe(() => {
		this.setState({
			article: store.getState().article
		})
	})
  }

  onChangeIndex = (selectedPage, lastPage) => {
  	actions.editorActions.setEditorSelectedPage(selectedPage)
  	actions.editorActions.setEditorPreviousPage(lastPage)
  }

	redirect = (route) => {
		const { history } = this.state

		actions.routeActions.changeRoute({
			route
		})

		history.push(route)
	}

  renderNewArticle = () => {
  	let newArticle = []

  	newArticle.push(
	  	<Paper
			style={{
				width: '100%',
				height: '100%',
				margin: 0,
				padding: 0,
				textAlign: 'center'
			}}
		>
			<div
				style={{
					width: '50%',
					height: '100%',
					display: 'inline-block',
					float: 'left'
				}}
			>
				<div
					style={{
						width: '50px',
						justifyContent: 'center',
						margin: 'calc(48% - 50px) auto 0'
					}}
				>
					<IconButton
						edge={ 'end' }
						className={ 'MenuButton' }
						color="inherit" 
						aria-label="menu"
						onClick={ this.redirect.bind(this, routes.ROUTE_ARTICLE) }
					>
						<Icon>
							<AddBoxOutlinedIcon />
						</Icon>
					</IconButton>
				</div>
			</div>

			<div
				style={{
					width: '50%',
					height: '100%',
					display: 'inline-block',
					float: 'right'
				}}
			>
				New Article
			</div>
		</Paper>
	)

	return newArticle
  }

  renderPaper = () => {
  	let paper = []

  	paper.push(
	  	<Paper
			style={{
				width: '100%',
				height: '100%',
				margin: 0,
				padding: 0,
				textAlign: 'center'
			}}
		>
			<div
				style={{
					width: '50%',
					height: '100%',
					display: 'inline-block',
					float: 'left'
				}}
			>
				Preview
			</div>

			<div
				style={{
					width: '50%',
					height: '100%',
					display: 'inline-block',
					float: 'right'
				}}
			>
				TITEL DES BEITRAGS
			</div>
		</Paper>
	)

	return paper
  }

  render() {
  	const {
  		article,
  		history
  	} = this.state

	  return (
	  	<div
	  		className="EditorOverview"
	  		style={{
	  			display: 'block',
	  			width: '100vw',
	  			height: 'calc(100vh - 80px - 200px)',
	  			padding: 0,
	  			margin: '80px 0 200px 0'
	  		}}
	  	>

	  		<table
	  			style={{
	  				width: '100%',
	  				height: '100%',
	  				padding: 0,
	  				margin: 0,
	  				borderSpacing: 0,
	  				border: 'none'
	  			}}
	  		>
	  			<tr>

					{
						['1', '2'].map((ii, index, array) => {
							let imageIndex = parseInt(ii)
							return (
								<td key={ii} >
							  		<EditorOverviewItem
										article={ article }
								  	  	history={ history }
								  	  	imageIndex={ imageIndex }
									/>
								</td>
							)
						})
					}
					
				</tr>
				<tr>

					{
						['3', '4'].map((ii, index, array) => {
							let imageIndex = parseInt(ii)
							// console.log(ii)
							// console.log(imageIndex)
							return (
								<td key={ii} >
							  		<EditorOverviewItem
										article={ article }
								  	  	history={ history }
								  	  	imageIndex={ imageIndex }
									/>
								</td>
							)
						})
					}
	  				
				</tr>
		  	</table>
  			
		</div>
	  );
	}
}

export default EditorOverview;